import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';

/**
 * Formata um tamanho em bytes para uma string legível (KB, MB, GB)
 * @param bytes Tamanho em bytes
 * @returns String formatada com unidade apropriada
 */
export const formatarTamanhoArquivo = (bytes: number): string => {
  if (bytes === 0) return '0 Bytes';

  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

// "04 de mai." → com ptBR o MMM já vem em português
export const formatarDataCurta = (data: Date | string): string => {
  try {
    return format(new Date(data), "dd 'de' MMM", { locale: ptBR });
  } catch {
    return String(data);
  }
};

// "04 de maio de 2025 14:30"
export const formatarDataLonga = (data: Date | string): string => {
  try {
    return format(new Date(data), "dd 'de' MMMM, yyyy HH:mm", { locale: ptBR });
  } catch {
    return String(data);
  }
};

// "1h 30min" | "45s" | "2d 3h"
export const formatarDuracao = (segundos: number): string => {
  if (segundos < 60) return `${segundos}s`;
  const minutos = Math.floor(segundos / 60);
  if (minutos < 60) return `${minutos}min`;
  const horas = Math.floor(minutos / 60);
  const mins = minutos % 60;
  if (horas < 24) return mins > 0 ? `${horas}h ${String(mins).padStart(2, '0')}min` : `${horas}h`;
  const dias = Math.floor(horas / 24);
  const hrs = horas % 24;
  return hrs > 0 ? `${dias}d ${hrs}h` : `${dias}d`;
};

// "04/05/2025"
export const formatarDataBR = (data: Date | string): string => {
  try {
    return new Date(data).toLocaleDateString('pt-BR');
  } catch {
    return String(data);
  }
};
